var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarTestEvidence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "verified_user_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.278,
    height: 21.278,
    viewBox: "0 0 21.278 21.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13565",
    "data-name": "Path 13565",
    d: "M0,0H21.278V21.278H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13566",
    "data-name": "Path 13566",
    d: "M10.639,1,3,4.505V9.763c0,4.863,3.259,9.411,7.639,10.515,4.38-1.1,7.639-5.652,7.639-10.515V4.505ZM16.58,9.763a9.162,9.162,0,0,1-5.941,8.7A9.162,9.162,0,0,1,4.7,9.763V5.644l5.941-2.725L16.58,5.644Zm-9.837.517-1.2,1.236,3.4,3.505,6.79-7.01-1.2-1.244L8.941,12.54Z",
    transform: "translate(0 0)",
    fill: "#9956cc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTestEvidence);
export default __webpack_public_path__ + "static/media/sidebar_test_evidence.a09766580a036f4eece28c3fc231e0c0.svg";
export { ForwardRef as ReactComponent };